import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Button,
    Stack,
} from '@mui/material';
import { t } from 'i18next';

function DeleteLocationDialog({
    deleteLocationDialogOpen,
    onCloseDeleteLocationDialog,
    onDeleteDeleteLocationDialog,
}) {
    return (
        <Dialog
            className="alignByLang"
            open={deleteLocationDialogOpen}
            onClose={onCloseDeleteLocationDialog}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <Typography variant="h6" align="center">
                    {t("Delete Location")}
                </Typography>
            </DialogTitle>

            <DialogContent>
                <Typography variant="body1" align="center">
                    {t("Are you sure you want to delete this location?")}
                </Typography>
            </DialogContent>

            <DialogActions>
                <Stack direction="row" spacing={2} justifyContent="center" width="100%" px={2} pb={2}>
                    <Button
                        onClick={onCloseDeleteLocationDialog}
                        variant="outlined"
                        color="primary"
                        fullWidth
                    >
                        {t("Cancel")}
                    </Button>
                    <Button
                        onClick={onDeleteDeleteLocationDialog}
                        variant="contained"
                        color="error"
                        fullWidth
                    >
                        {t("Delete")}
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
}

export default DeleteLocationDialog;
